
import React, { useEffect, useRef, useState } from 'react'

const useResizeDetector = () =>
{
	const [width, setWidth] = useState(window.innerWidth);
	const ref = useRef(null);
	
	useEffect(() =>
	{
		const element = ref.current;
		if (!element) return;
		
		const resizeObserver = new ResizeObserver(entries =>
		{
			if (entries[0])
			{
				setWidth(entries[0].contentRect.width);
			}
		});
		
		resizeObserver.observe(element);
		
		// Also listen to window resize as fallback
		const handleResize = () => setWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		
		return () =>
		{
			resizeObserver.disconnect();
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	
	return { width, ref };
};


// Create a functional component wrapper for resize detection
const ResizeDetectorWrapper = ({ children }) =>
{
	const { width, ref } = useResizeDetector()
	return (
		<div ref={ref}>
			{children(width)}
		</div>
	)
}

export default ResizeDetectorWrapper
